import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clear-form"
export default class extends Controller {
  static targets = ["input", "clearButton"]

  connect() {
    this.toggleClearButton();
    console.log("ClearForm controller connected")
  }

  toggleClearButton() {
    if (this.inputTarget.value) {
      this.clearButtonTarget.style.display = "inline";
    } else {
      this.clearButtonTarget.style.display = "none";
    }
  }

  clearInput() {
    this.inputTarget.value = "";
    this.inputTarget.dispatchEvent(new Event('input'));
    this.toggleClearButton();
  }

  inputChanged() {
    this.toggleClearButton();
  }
}
